<template>
  <article>
    <header>
      <h1 class="thin center">Meus Dados</h1>
    </header>

    <div v-if="servidorLoaded" class="row">
      <div class="col s12">
        <InfoCard v-bind="infoCard">
          <p>
            Confira, nas seções abaixo, seus dados pessoais, de documentação, de
            contato e funcionais (para cada vínculo) cadastrados na UFRJ.
          </p>
          <p>
            Você também pode, caso deseje, atualizar alguns dados cadastrais
            importando-os do SiapeNet. Para isso, basta clicar no botão
            "Atualizar". É recomendado realizar essa operação sempre que algum
            dado seja atualizado via Sigepe ou através de seu Departamento de
            Pessoal.
          </p>
        </InfoCard>
      </div>

      <div class="col s12">
        <BaseProgressBar v-if="importing" v-bind="progressBar"
          >Importando dados do SiapeNet...</BaseProgressBar
        >
      </div>

      <div class="col s12 buttons-row">
        <BaseButton
          v-bind="buttonUpdate"
          v-bind:disabled="loading || importing"
          v-on:click="atualizarDados"
        />
      </div>
    </div>

    <div v-if="loading" class="row">
      <div class="col s12">
        <BaseProgressBar v-bind="progressBar"
          >Carregando dados do servidor...</BaseProgressBar
        >
      </div>
    </div>
    <DadosServidor v-else-if="servidor" v-bind="servidor" />
  </article>
</template>

<script>
import { API_URL } from "../constants";
import DadosServidor from "../components/MeusDados/DadosServidor.vue";

const buildNotificationMessage = (vm, message, details) => {
  const { escapeHtml } = vm.$utils.Web;

  const p = message ? `<p>${escapeHtml(message)}</p>` : "";

  const li = (details || []).map(item => `<li>${escapeHtml(item)}</li>`);

  const ul = li.length ? `<ul class="browser-default">${li.join("")}</ul>` : "";

  return `${p}${ul}`;
};

export default {
  name: "MeusDados",
  components: {
    DadosServidor
  },
  inheritAttrs: false,
  props: {
    query: String
  },
  data() {
    return {
      importing: false,
      loading: false,
      // Variável de controle para exibir o botão de atualização dos dados com
      // os dados do SiapeNet somente quando os dados do servidor foram
      // carregados com sucesso pelo menos uma vez.
      servidorLoaded: false,
      progressBar: {
        useContainer: false
      },
      infoCard: {
        id: "sispessoal-meusdados-infocard",
        title: "Dados do servidor"
      },
      buttonUpdate: {
        iconName: "system_update_alt",
        content: "Atualizar",
        title: "Atualizar dados locais com os dados importados do SiapeNet"
      },
      servidor: null,
      servidorSchema: {
        pessoaFisica: {
          id: null,
          nome: null,
          nomeSocial: null,
          dataNascimento: null,
          sexo: null,
          cpf: null
        },
        detalhe: {
          id: null,
          nomeMae: null,
          nomePai: null,
          tipoSanguineo: null,
          fatorRh: null,
          naturalidadeMunicipioId: null,
          nacionalidade: {
            origemPaisId: null,
            dataChegada: null,
            tipoNacionalidadeCodigo: null
          },
          estadoCivil: null,
          etniaCodigo: null,
          pessoaFisicaId: null
        },
        documentacaoExtra: {
          id: null,
          carteiraIdentidade: {
            numero: null,
            orgao: null,
            uf: null,
            data: null
          },
          tituloEleitor: {
            numero: null,
            dataEmissao: null,
            zona: null,
            secao: null,
            uf: null
          },
          pisPasep: null,
          carteiraMotorista: {
            numero: null,
            registro: null,
            categoria: null,
            dataExpedicao: null,
            dataValidade: null,
            uf: null,
            dataPrimeiraExpedicao: null
          },
          comprovanteMilitar: {
            numero: null,
            orgao: null,
            serie: null,
            data: null
          },
          passaporte: {
            numero: null,
            orgao: null,
            expedicao: null,
            tipo: null,
            vistoNumero: null,
            vistoTipo: null,
            vistoValidade: null,
            vistoDuracaoMeses: null
          },
          pessoaFisicaId: null
        },
        endereco: [
          {
            id: null,
            logradouro: null,
            numero: null,
            complemento: null,
            bairro: null,
            cep: null,
            municipioId: null,
            preferencia: null,
            tipoEndereco: null,
            pessoaFisicaId: null
          }
        ],
        telefone: [
          {
            id: null,
            ddd: null,
            telefone: null,
            preferencia: null,
            tipoTelefone: null,
            pessoaFisicaId: null
          }
        ],
        email: [
          {
            id: null,
            email: null,
            preferencia: null,
            tipoEmail: null,
            pessoaFisicaId: null
          }
        ],
        deficiencia: [
          {
            id: null,
            tipoDeficienciaCodigo: null,
            principal: null,
            pessoaFisicaId: null
          }
        ],
        dadoEscolar: [
          {
            id: null,
            escolaridadeNome: null,
            escolaridadeCodigo: null,
            dataConclusao: null,
            instituicaoEnsinoId: null,
            pessoaFisicaId: null
          }
        ],
        dadoFuncional: [
          {
            id: null,
            siape: null,
            orgaoOrigemCodigo: null,
            orgaoOrigemNome: null,
            cargoCodigo: null,
            cargoNome: null,
            funcaoCodigo: null,
            funcaoNome: null,
            classeCodigo: null,
            classeNome: null,
            padrao: null,
            situacaoFuncionalCodigo: null,
            situacaoFuncionalNome: null,
            lotacaoId: null,
            lotacaoCodigo: null,
            lotacaoNome: null,
            localizacaoId: null,
            localizacaoCodigo: null,
            localizacaoNome: null,
            regimeJuridicoCodigo: null,
            regimeJuridicoNome: null,
            jornadaCodigo: null,
            jornadaNome: null,
            contratoTemporarioTermino: null,
            implantado: null,
            pessoaFisicaId: null,
            dadoBancarioId: null,
            ingressoServicoPublicoData: null,
            ingressoServicoPublicoOcorrenciaTipoCodigo: null,
            ingressoOrgaoData: null,
            ingressoOrgaoOcorrenciaTipoCodigo: null,
            exclusaoData: null,
            exclusaoOcorrenciaTipoCodigo: null,
            aposentadoriaData: null,
            aposentadoriaOcorrenciaTipoCodigo: null,
            pssInicioData: null,
            pssFimData: null,
            pssOcorrenciaTipoCodigo: null,
            admissaoDiplomaLegalNumero: null,
            admissaoDiplomaLegalData: null,
            admissaoDiplomaLegalTipoCodigo: null,
            unidadePagadoraCodigo: null,
            unidadePagadoraNome: null,
            unidadeOrganizacionalLotacaoCodigo: null,
            unidadeOrganizacionalLotacaoNome: null,
            unidadeOrganizacionalExercicioCodigo: null,
            unidadeOrganizacionalExercicioNome: null,
            valeTransporteValor: null
          }
        ]
      }
    };
  },
  watch: {
    "$store.state.user"(newUser, oldUser) {
      if (newUser) {
        if (oldUser) {
          if (newUser.id !== oldUser.id) {
            this.searchFunction(newUser);
          }
        } else {
          this.searchFunction(newUser);
        }
      }
    }
  },
  created() {
    this.getDadosServidor();
  },
  methods: {
    getDadosServidor() {
      if (this.$store.state.user) {
        this.searchFunction(this.$store.state.user);
      }
    },
    atualizarDados() {
      if (!this.$store.state.user) {
        return;
      }

      this.importing = true;

      const cpf = this.$store.state.user.document;

      this.$http
        .post(`${API_URL}/core/siape/sincronizar/${cpf}`)
        .then(response => {
          const { severidade, mensagem, detalhes } = response.data;

          if (severidade === "ERRO") {
            return Promise.reject(new Error(mensagem));
          } else if (severidade === "AVISO") {
            this.$notification.pushWarning(
              buildNotificationMessage(this, mensagem, detalhes)
            );
          } else if (severidade === "INFORMATIVO") {
            this.$notification.pushSuccess(
              "Dados do servidor importados do SiapeNet com sucesso"
            );
          }

          this.getDadosServidor();
        })
        .catch(error =>
          this.$notification.pushError(
            `Houve um erro ao importar dados do SiapeNet: ${error.message}`
          )
        )
        .finally(() => (this.importing = false));
    },
    searchFunction(responsavel) {
      const cpf = responsavel.document;

      if (!cpf) {
        return this.$notification.pushError(
          "Identificador de usuário inválido"
        );
      }

      this.loading = true;

      this.servidor = null;

      const servidorTmp = {};

      this.$http
        .get(`${API_URL}/core/pessoaFisica/cpf/${cpf}`)
        .then(response => {
          const pessoaFisicaId = response.data.id;

          const baseUrl = `${API_URL}/core/pessoaFisica/${pessoaFisicaId}`;

          const entities = [
            { name: "pessoaFisica", url: baseUrl },
            { name: "detalhe", url: baseUrl + "/detalhe" },
            { name: "documentacaoExtra", url: baseUrl + "/documentacaoExtra" },
            { name: "endereco", url: baseUrl + "/endereco" },
            { name: "telefone", url: baseUrl + "/telefone" },
            { name: "email", url: baseUrl + "/email" },
            { name: "deficiencia", url: baseUrl + "/deficiencia" },
            { name: "dadoEscolar", url: baseUrl + "/dadoEscolar" },
            { name: "dadoFuncional", url: baseUrl + "/dadoFuncional" }
          ];

          return Promise.all(
            entities.map(item => this.$http.get(item.url))
          ).then(response => {
            entities.forEach((item, index) => {
              servidorTmp[item.name] = response[index].data;
            });

            const vinculos = servidorTmp.dadoFuncional || [];

            return Promise.all(
              vinculos.map(item =>
                this.$http.get(
                  `${API_URL}/core/dadoFuncional/${item.id}/detalhe`
                )
              )
            ).then(response => {
              servidorTmp.dadoFuncional = response.map(item => item.data || {});

              this.servidor = this.$utils.Object.applySchema(
                servidorTmp,
                this.servidorSchema
              );

              this.servidorLoaded = true;

              this.$notification.pushSuccess(
                "Dados do servidor carregado com sucesso"
              );
            });
          });
        })
        .catch(error =>
          this.$notification.pushError(
            `Houve um erro ao obter os dados do servidor: ${error.message}`
          )
        )
        .finally(() => (this.loading = false));
    }
  }
};
</script>

<style scoped>
.buttons-row {
  justify-content: center;
}
</style>
